module.exports = __webpack_public_path__ + "media/question3_en.e1d296f1.mp3";